import React from 'react';
import { RefreshCw, Microscope, ShieldCheck } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function Mechanism() {
  return <section className="py-20 px-4 bg-teal-50" data-id="element-132">
      <div className="max-w-4xl mx-auto" data-id="element-133">
        <div className="text-center mb-12" data-id="element-134">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-teal-600 text-white rounded-2xl shadow-lg mb-6 transform rotate-3" data-id="element-135">
            <Microscope className="w-8 h-8" data-id="element-136" />
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-6" data-id="element-137">
            El Método MIC:{' '}
            <span className="text-teal-600" data-id="element-138">Interrupción del Ciclo</span>
          </h2>
          <p className="text-xl text-slate-600 font-medium max-w-2xl mx-auto" data-id="element-139">
            No buscamos una "cura mágica". Es un protocolo de ingeniería
            biológica de 168 horas.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl border border-teal-100 overflow-hidden mb-12" data-id="element-140">
          <div className="grid md:grid-cols-2" data-id="element-141">
            <div className="p-8 md:p-10 bg-teal-600 text-white flex flex-col justify-center relative overflow-hidden" data-id="element-142">
              <RefreshCw className="absolute -right-10 -bottom-10 w-64 h-64 text-teal-500 opacity-20" data-id="element-143" />
              <h3 className="text-2xl font-bold mb-4 relative z-10" data-id="element-144">
                Asfixia Mecánica + Calendario Táctico
              </h3>
              <p className="text-teal-50 text-lg leading-relaxed relative z-10" data-id="element-145">
                En lugar de usar químicos tóxicos, utilizamos asfixia mecánica y
                un calendario de remoción táctica.
              </p>
            </div>

            <div className="p-8 md:p-10 flex flex-col justify-center" data-id="element-146">
              <ul className="space-y-6" data-id="element-147">
                <li className="flex gap-4" data-id="element-148">
                  <div className="w-8 h-8 rounded-full bg-teal-100 text-teal-700 flex items-center justify-center font-bold flex-shrink-0" data-id="element-149">
                    1
                  </div>
                  <div data-id="element-150">
                    <h4 className="font-bold text-slate-900" data-id="element-151">
                      Ataque Estratégico
                    </h4>
                    <p className="text-slate-600 text-sm mt-1" data-id="element-152">
                      Atacamos en días específicos basados en la eclosión del
                      parásito.
                    </p>
                  </div>
                </li>
                <li className="flex gap-4" data-id="element-153">
                  <div className="w-8 h-8 rounded-full bg-teal-100 text-teal-700 flex items-center justify-center font-bold flex-shrink-0" data-id="element-154">
                    2
                  </div>
                  <div data-id="element-155">
                    <h4 className="font-bold text-slate-900" data-id="element-156">
                      Garantía Biológica
                    </h4>
                    <p className="text-slate-600 text-sm mt-1" data-id="element-157">
                      Garantizamos que ninguna ninfa llegue a la edad adulta
                      para poner más huevos.
                    </p>
                  </div>
                </li>
                <li className="flex gap-4" data-id="element-158">
                  <div className="w-8 h-8 rounded-full bg-teal-600 text-white flex items-center justify-center flex-shrink-0" data-id="element-159">
                    <ShieldCheck className="w-5 h-5" data-id="element-160" />
                  </div>
                  <div data-id="element-161">
                    <h4 className="font-bold text-teal-700" data-id="element-162">
                      Resultado Definitivo
                    </h4>
                    <p className="text-slate-900 font-medium mt-1" data-id="element-163">
                      Si cortas el ciclo, el problema muere.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex justify-center" data-id="element-164">
          <CTAButton data-id="element-165" />
        </div>
      </div>
    </section>;
}